<template>
    <div>
        <div class="text-right">
            <input type="text" v-model="searchTerm" placeholder="Meklēt pēc nosaukuma..."
                   class="mb-4 px-4 py-2 ds-input" @input="attemptSearch">
        </div>

        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <div class="row d-flex align-items-stretch" v-else>
            <CompaniesListItem class="col-sm-4 mb-4" v-for="company in companies" :key="company._id" :company="company"/>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import SkeletonLoader from '../global/skeleton-loader/SkeletonLoader';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import CompaniesListItem from './CompaniesListItem';

    export default {
        name: 'companies-list',
        components: {CompaniesListItem, SkeletonLoader},
        data: () => ({
            skeletonData: SkeletonLoaderRepository.companiesLayout,
            searchTerm: '',
            searchTimeout: null,
        }),
        created() {
            this.getCompanies();
        },
        methods: {
            ...mapActions('company', {
                /** @type {function|*} */
                getCompanies: companyStoreTypes.ACTION_GET_COMPANIES,
            }),
            /**
             * Search company by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);

                this.searchTimeout = setTimeout(() => {
                    this.getCompanies(this.searchTerm);
                }, 500);
            },
        },
        computed: mapGetters('company', {
            /** @type {boolean|*} */
            isLoading: companyStoreTypes.GET_IS_LOADING,
            /** @type {Company[]|*} */
            companies: companyStoreTypes.GET_COMPANIES,
        }),
    }
</script>